import { createContext } from "react";
import { IMQTTListenerContext } from "./MQTTListenerContextInterfaces";

export const initialState: IMQTTListenerContext = {
    isListening: false,
};

export const MQTTListenerContext = createContext(initialState);
